import axios from "../../../../utils/axios";

export const login = async (creds) => {
  const res = await axios.get("/account/login", {
    auth: { username: creds.username, password: creds.password },
    withCredentials: false,
  });

  return res;
};

export const logout = async () => {
  try {
    const res = await axios.get("/logout", { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error(error);
  }
};
